import LocalStorage from '../../data/local-storage';
import CONFIG from '../../config/app-config';
import AuthService from '../../services/auth-service';
import { calculateDistance } from '../../utils/helpers';
import BookmarkService from '../../services/bookmark-service';
import { getLocationName as fetchLocationName } from '../../services/location-service';

export default class BookmarksModel {
  constructor() {
    this.bookmarks = [];
    this.isAuthenticated = false;
    this.user = {};
    this.currentUserLocation = null;
  }

  loadUserState() {
    const { isAuthenticated, user } = AuthService;
    this.isAuthenticated = isAuthenticated;
    this.user = user || {};
    this.bookmarks = BookmarkService.getBookmarks();

    if (isAuthenticated && user.id) {
      this.currentUserLocation = LocalStorage.getUserSpecificObject(
        'heliaedu_user_location',
        user.id
      );
    } else {
      this.currentUserLocation = null;
      this.bookmarks = [];
    }
  }

  getBookmarks() {
    return this.bookmarks;
  }

  removeBookmark(storyId) {
    const count = BookmarkService.removeBookmark(storyId);
    this.bookmarks = BookmarkService.getBookmarks();
    return count > 0;
  }

  clearAllBookmarks() {
    BookmarkService.setBookmarks([]);
    this.bookmarks = [];
    return true;
  }

  getBookmarkCount() {
    return this.bookmarks.length;
  }

  getBookmarksWithDistance() {
    if (!this.currentUserLocation) {
      return this.bookmarks.map((bookmark) => ({
        ...bookmark,
        distance: null,
      }));
    }

    return this.bookmarks.map((bookmark) => {
      let distance = null;
      if (bookmark.lat && bookmark.lon && this.currentUserLocation) {
        distance = calculateDistance(
          this.currentUserLocation.lat,
          this.currentUserLocation.lon,
          bookmark.lat,
          bookmark.lon
        );
      }
      return {
        ...bookmark,
        distance,
      };
    });
  }

  async getLocationName(lat, lon) {
    return fetchLocationName(lat, lon);
  }

  getSortedBookmarks() {
    return [...this.bookmarks].sort((a, b) => new Date(b.savedAt) - new Date(a.savedAt));
  }

  getBookmarkStats() {
    const totalBookmarks = this.bookmarks.length;
    const withLocation = this.bookmarks.filter((b) => b.lat && b.lon).length;
    const withImages = this.bookmarks.filter((b) => b.photoUrl).length;

    return {
      total: totalBookmarks,
      withLocation,
      withImages,
    };
  }

  setBookmarks(bookmarks) {
    this.bookmarks = bookmarks;
  }

  updateGlobalBookmarks(newBookmarks) {
    this.bookmarks = newBookmarks;
  }
}
